import script from "./ProfileLanguageDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileLanguageDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ProfileLanguageDrawer.vue?vue&type=style&index=0&id=dc73b570&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc73b570"]])

export default __exports__